module.exports = __webpack_public_path__ + "img/xinxikeji1.137e3d3f.jpg";